<template>
  <div class="container">
    <wrap-container class="relative-container column-container">
      <step-header />

      <form-validator>
        <wrap-container>
          <section-label
            :value="isPF ? config.pasos.paso2.copyPF : config.pasos.paso2.copy"
          />
          <enterprise-activity
            class="margin-btn-24"
            v-model="model.tipoActividad"
            label="Seleccioná una opción"
          />
        </wrap-container>

        <wrap-container>
          <section-label value="Rango de Facturación" />
          <billing-range
            class="margin-btn-24"
            v-model="model.rangoFacturacion"
            :tipoActividad="model.tipoActividad"
            label="Seleccioná una opción"
            v-on:resetValue="resetRango"
          />
        </wrap-container>

        <wrap-container v-if="isPF">
          <section-label value="¿Cómo necesitás cobrar?" />
          <TypePay
            class="margin-btn-24"
            v-model="model.tipoDeCobro"
            label="Seleccioná una opción"
          />
        </wrap-container>

        <wrap-container v-if="isPF" class="mb-30">
          <section-label value="¿Dónde necesitás cobrar?" />
          <CheckBoxPlacePay
            :options="lugarDeCobroOpciones"
            v-model="model.lugarDeCobro"
            :required="true"
          />
        </wrap-container>

        <wrap-container v-if="isPF">
          <section-label value="¿Cuál es el volumen de operaciones?" />
          <CheckBoxPlacePay
            :options="volumenDeOperacionesOpciones"
            v-model="model.volumenDeOperaciones"
            :required="true"
          />
        </wrap-container>

        <step-navigator :store-action="this.doNext" v-model="model" />
      </form-validator>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepNavigator from "@/components/core/StepNavigator";
import StepHeader from "@/components/core/StepHeader";
import SectionLabel from "@/components/core/SectionLabel";
import EnterpriseActivity from "@/components/core/custom/EnterpriseActivity";
import BillingRange from "@/components/core/custom/BillingRange";
import TypePay from "@/components/core/custom/TypePay";
import CheckBoxPlacePay from "@/components/core/custom/CheckBoxPlacePay";
import { DO_PASO2 } from "@/config/constants/action-types";
import * as ACTIONS from "@/config/constants/action-types";
import { volumenDeOperaciones, lugarDeCobro } from "@/config/constants";

const environment = process.env.NODE_ENV || "production";

export default {
  name: "Paso2",
  data() {
    return {
      model: this.$store.getters.getPaso2(),
      doNext: DO_PASO2,
      isProduction: environment === "production"
    };
  },
  computed: {
    isPF() {
      return this.$store.getters.getPaso1().esPF === true;
    },
    lugarDeCobroOpciones() {
      return lugarDeCobro;
    },
    volumenDeOperacionesOpciones() {
      return volumenDeOperaciones;
    }
  },
  mounted() {
    this.model.rangoFacturacion = "";
    this.model.tipoActividad = "";
    this.model.tipoDeCobro = "";
    this.model.lugarDeCobro = "";
    this.model.volumenDeOperaciones = "";
  },
  methods: {
    resetRango() {
      this.model.rangoFacturacion = "";
    },
    trackClick(el) {
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    }
  },
  components: {
    WrapContainer,
    FormValidator,
    StepNavigator,
    StepHeader,
    SectionLabel,
    EnterpriseActivity,
    BillingRange,
    TypePay,
    CheckBoxPlacePay
  }
};
</script>
<style scoped>
.terms-and-cond {
  margin: 40px 0;
}

.terms-and-cond span {
  cursor: pointer;
  color: #237aba;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.mb-30 {
  margin-bottom: 30px;
}

@media screen and (max-width: 600px) {
  .terms-and-cond span {
    display: block;
  }
}
</style>
